import { render } from "./EditDashboardForOrganisation.vue?vue&type=template&id=37ce771e"
import script from "./EditDashboardForOrganisation.vue?vue&type=script&lang=js"
export * from "./EditDashboardForOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__